import React from 'react';

const StatCard = ({ icon, label, val, color }) => {
  return (
    <div className="col-xl-3 col-md-6">
      <div className="card border-0 shadow-sm h-100 p-3" style={{ borderRadius: '12px' }}>
        {/* Card Header: Icon and Label */}
        <div className="d-flex align-items-center mb-3">
          <div className={`bg-${color}-subtle text-${color} p-2 rounded-3 me-3 d-flex align-items-center justify-content-center`} 
               style={{ width: '40px', height: '40px' }}>
            <i className={`bi ${icon} fs-5`}></i>
          </div>
          <span className="text-muted small fw-bold text-uppercase">{label}</span>
          <i className="bi bi-three-dots-vertical ms-auto text-muted cursor-pointer"></i>
        </div>

        {/* Card Body: Main Value and Trend */}
        <div className="d-flex justify-content-between align-items-end">
          <div>
            <h4 className="fw-bold mb-0">{val}</h4>
            <div className="mt-1">
               <span className="text-success small fw-bold">↗ 30.6%</span>
            </div>
          </div>
          
          {/* Sparkline Placeholder - Matches the blue bars in reference */}
          <div className="mini-chart d-flex align-items-end gap-1" style={{ height: '30px' }}>
             <div className="bg-primary opacity-25" style={{ width: '4px', height: '15px', borderRadius: '2px' }}></div>
             <div className="bg-primary opacity-50" style={{ width: '4px', height: '25px', borderRadius: '2px' }}></div>
             <div className="bg-primary opacity-25" style={{ width: '4px', height: '10px', borderRadius: '2px' }}></div>
             <div className="bg-primary" style={{ width: '4px', height: '20px', borderRadius: '2px' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;